import { useCallback } from "react";

import { useEventTrackerService } from "@vahak/core/dist/_services";
import { GA4EventNames, WEB_V2_SOURCE_SCREENS } from "@vahak/core/dist/constants/event-names";
import { GenericObject } from "@vahak/core-ui/dist/types";

import { LoginEventTracker } from "../../login-form-new/hooks/auth/loginAuthAnalytics";

const COMPACT_AUTH_EVENT_MAP: Partial<Record<string, string>> = {
    [GA4EventNames.LOGIN_OR_SIGNUP_MODAL.get_otp_clicked]: GA4EventNames.WEB_V2.get_otp_clicked,
    [GA4EventNames.LOGIN_OR_SIGNUP_MODAL.otp_submit]: GA4EventNames.WEB_V2.otp_submit,
    [GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_signup]: GA4EventNames.WEB_V2.user_signup,
    [GA4EventNames.COMPANY_REGISTRATION.user_registered]: GA4EventNames.WEB_V2.user_registered
};

const SKIP_LEGACY_AUTH_EVENTS = new Set<string>([
    GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_login,
    GA4EventNames.COMPANY_REGISTRATION.company_details_submitted
]);

/** Maps compact auth login events to WEB_V2 onb_form funnel events. */
export function useCompactAuthWebV2Tracking(phoneNum?: string | number): LoginEventTracker {
    const { sendGAandMoEngageEvent } = useEventTrackerService();

    return useCallback(
        (name: string, data?: GenericObject) => {
            if (SKIP_LEGACY_AUTH_EVENTS.has(name)) {
                return;
            }

            const mappedName = COMPACT_AUTH_EVENT_MAP[name];
            if (!mappedName) {
                return;
            }

            sendGAandMoEngageEvent({
                name: mappedName,
                data: {
                    source_screen: WEB_V2_SOURCE_SCREENS.ONB_FORM,
                    ...(phoneNum != null ? { Number: phoneNum } : {}),
                    ...data
                }
            });
        },
        [phoneNum, sendGAandMoEngageEvent]
    );
}
